import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import LeakBoard from "@/pages/LeakBoard";
import Accounts from "@/pages/Accounts";
import AccountDetail from "@/pages/AccountDetail";
import Sites from "@/pages/Sites";
import SiteDetail from "@/pages/SiteDetail";
import Snapshot from "@/pages/Snapshot";
import Thresholds from "@/pages/Thresholds";
import DataHealth from "@/pages/DataHealth";
import SetPassword from "@/pages/SetPassword";
import Users from "@/pages/Users";
import Connection from "@/pages/Connection";

function Protected({ children, adminOnly, superOnly }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustSetPassword) return <Navigate to="/set-password" replace />;
  if (superOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
  if (adminOnly && !(user.role === "admin" || user.role === "super_admin"))
    return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<LeakBoard />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/accounts/:id" element={<AccountDetail />} />
            <Route path="/sites" element={<Sites />} />
            <Route path="/sites/:id" element={<SiteDetail />} />
            <Route path="/snapshot" element={<Snapshot />} />
            <Route path="/snapshot/:id" element={<Snapshot />} />
            <Route path="/thresholds" element={<Protected adminOnly><Thresholds /></Protected>} />
            <Route path="/connection" element={<Protected superOnly><Connection /></Protected>} />
            <Route path="/users" element={<Protected superOnly><Users /></Protected>} />
            <Route path="/health" element={<DataHealth />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
